module.exports = __webpack_public_path__ + "static/media/clubs_6.8c0b6a6e.png";